import { Notyf } from 'notyf';
import '@molsoft-io/multilingual-module';
import 'notyf/notyf.min.css';

/**
 * the intersection-observer polyfill
 * is fairly important as it is recent on IOS
 */
import 'intersection-observer';
import '../utils/lazy-resources';

// import '../../styles/theme.scss';

import '../sections/header';

import {
  initiateBreakpoinListener
} from '../utils/breakpoints';

initiateBreakpoinListener();

// Toast notifications
window.toast = new Notyf({
  ripple: false,
  position: {
    x: 'right',
    y: 'bottom'
  },
  dismissible: true,
  duration: 5000
});


import '../components/quantity-input';
